import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      {/* Item/s: */}
      <Route
        path='/inventory/:groupId/item/edit/:itemId'
        component={Loadable(() => import('./Item/Item.container'))}
      />
      <Route
        path='/inventory/:groupId/item/add'
        component={Loadable(() => import('./Item/Item.container'))}
      />
      {/* Group/s: */}
      <Route
        path='/inventory/view/:groupId'
        component={Loadable(() => import('./Group/Group.container'))}
      />
      <Route
        path='/inventory/add'
        component={Loadable(() => import('./GroupAdd/GroupAdd.container'))}
      />
      <Route path='/inventory' component={Loadable(() => import('./Groups/Groups.container'))} />
    </Switch>
  )
}

export default routes
